module.exports = __webpack_public_path__ + "static/fonts/PlusJakartaDisplay-Regular.4bc65540.woff2";